<template>
    <section id="servico-aberto">
        <button class="x" @click.stop="$emit('fechar')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x preview-icon"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>

        <section class="centeudo-servico-aberto">
            <div class="fotos-servico">
                <img :src="servicoAberto.foto[fotoAtual || 0]" :key="fotoAtual || 0" alt="servico" class="foto-servico-aberto">

                <div class="indicadores-fotos">
                    <button
                        v-for="(foto, fotoIndex) in servicoAberto.foto"
                        :key="fotoIndex"
                        :class="{ ativo: (fotoAtual || 0) === fotoIndex }"
                        @click.stop="fotoAtual = fotoIndex"
                    ></button>
                </div>
            </div>

            <div class="textos-servico-aberto">
                <div class="textos-inicio">
                    <h2 class="titulo-servico-aberto">{{ servicoAberto?.titulo }}</h2>
                    <p class="descricao-servico-aberto">{{ servicoAberto?.descricao }}</p>
                </div>

                <div class="dados-ui-fundo">
                    <p class="dados-ui">
                        <span
                            v-for="estrela in 5"
                            :key="estrela"
                            class="estrela"
                            :style="{
                                '--preenchimento': `${Math.min(Math.max(servicoAberto.avaliacao - (estrela - 1), 0), 1) * 100}%`
                            }"
                        >
                            ★
                        </span>
                        <span class="nota">{{ servicoAberto?.avaliacao }}</span>
                    </p>

                    <p class="dados-ui-texto">+ {{ servicoAberto?.total_feito }}</p>
                </div>

                <button class="contratar-servico" @click.stop="abrirWhatsApp(servicoAberto)">
                    <img src="@/assets/whatsapp-icon.svg" alt="wp" class="icon-botao-wp">
                    Fazer orçamento
                </button>
            </div>
        </section>
    </section>

</template>

<script>
export default{
    name: 'ServicoAbertoLandingPage',

    props:{
        servicoAberto: Object
    },

    data(){
        return{
            fotoAtual: 0
        }
    },

    methods: {
        abrirWhatsApp(servico) {
            window.open(
                servico.link_whatsapp,
                '_blank'
            )
        }
    },

    mounted() {
        this.fotoAtual = 0;

        this.intervaloFotos = setInterval(() => {
            if (!this.servicoAberto?.foto?.length) return;
            
            this.fotoAtual =
                (this.fotoAtual + 1) % this.servicoAberto.foto.length;
        }, 4000);
    
    }
}
</script>

<style scoped>
#servico-aberto{
    height: 90vh;
    width: 70%;
    background-color: #ffffff;
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: 30px;
    animation: aparecer 0.4s ease-in;
}

.x{
    position: absolute;
    top: 10px;
    right: 10px;
}

.centeudo-servico-aberto{
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
}

.fotos-servico{
    width: 100%;
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
}

.foto-servico-aberto{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.indicadores-fotos {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    gap: 6px;
}

.indicadores-fotos button {
    width: 7px;
    height: 7px;
    padding: 0;

    border: none;
    border-radius: 10px;

    background-color: rgba(255, 255, 255, 0.6);

    cursor: pointer;
    transition: 0.2s;
}

.indicadores-fotos button.ativo {
    background-color: #fff;
}

.textos-servico-aberto{
    display: flex;
    flex-direction: column;
}

.textos-inicio{
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.titulo-servico-aberto{
    font-size: 24px;
    color: #3e3e3e;
}

.descricao-servico-aberto{
    font-size: 16px;
    color: #3e3e3ebe;
}

.dados-ui-fundo{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2px;
    padding: 0 6px 0 0;
    margin-top: 8px;
}

.dados-ui {
    font-size: 15px;
    color: #3e3e3e;
    display: flex;
    align-items: center;
    gap: 1px;
}

.estrela {
    font-size: 18px;
    color: transparent !important;

    background: linear-gradient(
        90deg,
        #f5b301 var(--preenchimento),
        #d9d9d9 var(--preenchimento)
    );

    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.nota {
    margin-left: 6px;
    color: #555;
    font-size: 13px;
}

.dados-ui-texto{
    font-size: 12px;
    font-weight: 400;
    color: #3e3e3e;
    text-decoration: underline;
}

.contratar-servico{
    width: 100%;
    padding: 16px 32px;
    border-radius: 100px;
    margin-top: 34px;
    background: none;
    border: solid 1.5px #25D366;
    color: #25D366;
    font-size: 14px;
    font-weight: 450;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all ease 0.4s;
}

.contratar-servico:hover{
    background-color: #25D366;
    color: #fff;
}

.contratar-servico:hover .icon-botao-wp{
    filter: brightness(0) invert(1);
}

.icon-botao-wp{
    position: absolute;
    left: 16px;
    width: 22px;
    height: 22px;
}

@media (min-width: 768px) and (max-width: 1200px){
    #servico-aberto{
        width: 90%;
        max-width: 900px;
        max-height: 85vh;
        height: auto;
        padding: 42px 24px;
        box-sizing: border-box;
        overflow-y: auto;
    }
    
    .centeudo-servico-aberto{
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px){
    #servico-aberto{
        width: 90%;
        height: 70vh;
        padding: 42px 24px;
    }

    .centeudo-servico-aberto{
        grid-template-columns: 1fr;
    }

    .titulo-servico-aberto{
        font-size: 16px;
    }

    .descricao-servico-aberto{
        font-size: 14px;
    }
}
</style>